import { BASE_WEIGHTS_KG } from "@biosany/shared"
import { catalogPriceId, imageBaseURL } from "@/lib/utils"
import { PRODUCT_SLUGS } from "./slugs"

export type ProductType = "shalosh-bayom" | "dermogel" | "taftefet" | "agua-vita" | "lazihum" | "nazelet" | "jabon-neutro" | "te"

export interface ProductImage {
	source: string
	width: number
	height: number
	alt: string
}

export interface ProductProps {
	id: ProductType
	name: string
	title: string
	description: string
	set: string
	price: number
	priceId: string
	weight: number
	image: ProductImage
	imageCheckout: ProductImage
	imageGallery: string
}

const img = (file: string): string => imageBaseURL(`products/${file}`)

const PRODUCTS: Record<ProductType, ProductProps> = {
	"shalosh-bayom": {
		id: "shalosh-bayom",
		name: "Shalósh Bayóm",
		title: "Solución con tecnología de avanzada",
		description: "",
		set: "Botella de 1 litro",
		price: 790,
		priceId: catalogPriceId("shalosh-bayom"),
		weight: BASE_WEIGHTS_KG["shalosh-bayom"]!,
		image: { source: img("shalosh.webp"), width: 600, height: 800, alt: "Shalósh Bayóm" },
		imageCheckout: { source: img("checkout/shalosh.webp"), width: 150, height: 200, alt: "Shalósh Bayóm" },
		imageGallery: img("gallery/shalosh.webp")
	},
	dermogel: {
		id: "dermogel",
		name: "DermoGel",
		title: "Efecto súper oxidante en la piel",
		description: "",
		set: "Frasco de 240 gr",
		price: 550,
		priceId: catalogPriceId("dermogel"),
		weight: BASE_WEIGHTS_KG["dermogel"]!,
		image: { source: img("dermogel.webp"), width: 600, height: 800, alt: "DermoGel" },
		imageCheckout: { source: img("checkout/dermogel.webp"), width: 150, height: 200, alt: "DermoGel" },
		imageGallery: img("gallery/dermogel.webp")
	},
	taftefet: {
		id: "taftefet",
		name: "Taftéfet",
		title: "Alivia tus sentidos de la vista, olfato y oídos",
		description: "",
		set: "Gotero de 30ml",
		price: 320,
		priceId: catalogPriceId("taftefet"),
		weight: BASE_WEIGHTS_KG["taftefet"]!,
		image: { source: img("taftefet.webp"), width: 600, height: 800, alt: "Taftéfet" },
		imageCheckout: { source: img("checkout/taftefet.webp"), width: 150, height: 200, alt: "Taftéfet" },
		imageGallery: img("gallery/taftefet.webp")
	},
	"agua-vita": {
		id: "agua-vita",
		name: "Agua Vita",
		title: "Agua alcalina rica en antioxidantes",
		description: "",
		set: "Botella de 1 litro",
		price: 69,
		priceId: catalogPriceId("agua-vita"),
		weight: BASE_WEIGHTS_KG["agua-vita"]!,
		image: { source: img("vita.webp"), width: 600, height: 800, alt: "Agua Vita" },
		imageCheckout: { source: img("checkout/vita.webp"), width: 150, height: 200, alt: "Agua Vita" },
		imageGallery: img("gallery/vita.webp")
	},
	lazihum: {
		id: "lazihum",
		name: "Lazihúm",
		title: "Elimina y previene las infecciones",
		description: "",
		set: "Frasco de 125 ml",
		price: 372,
		priceId: catalogPriceId("lazihum"),
		weight: BASE_WEIGHTS_KG["lazihum"]!,
		image: { source: img("lazihum.webp"), width: 600, height: 800, alt: "Lazihúm" },
		imageCheckout: { source: img("checkout/lazihum.webp"), width: 150, height: 200, alt: "Lazihúm" },
		imageGallery: img("gallery/lazihum.webp")
	},
	nazelet: {
		id: "nazelet",
		name: "Nazélet",
		title: "Libera tus vías respiratorias",
		description: "",
		set: "Caja con 6 frascos de 12ml c/u",
		price: 717,
		priceId: catalogPriceId("nazelet"),
		weight: BASE_WEIGHTS_KG["nazelet"]!,
		image: { source: img("nazelet.webp"), width: 600, height: 800, alt: "Nazélet" },
		imageCheckout: { source: img("checkout/nazelet.webp"), width: 150, height: 200, alt: "Nazélet" },
		imageGallery: img("gallery/nazelet.webp")
	},
	"jabon-neutro": {
		id: "jabon-neutro",
		name: "Jabón Neutro",
		title: "Logra una asepsia instantánea",
		description: "",
		set: "Solución de 125ml",
		price: 180,
		priceId: catalogPriceId("jabon-neutro"),
		weight: BASE_WEIGHTS_KG["jabon-neutro"]!,
		image: { source: img("jabon.webp"), width: 600, height: 800, alt: "Jabón Neutro" },
		imageCheckout: { source: img("checkout/jabon.webp"), width: 150, height: 200, alt: "Jabón Neutro" },
		imageGallery: img("gallery/jabon.webp")
	},
	te: {
		id: "te",
		name: "Té",
		title: "Tés e infusiones sanadoras",
		description: "",
		set: "Bolsa de 10g",
		price: 35,
		priceId: catalogPriceId("te"),
		weight: BASE_WEIGHTS_KG["te"]!,
		image: { source: img("te.webp"), width: 600, height: 800, alt: "Tés e infusiones" },
		imageCheckout: { source: img("checkout/te.webp"), width: 150, height: 200, alt: "Tés e infusiones" },
		imageGallery: img("gallery/te.webp")
	}
}

/** Slugs that get pre-rendered as /productos/:slug (todos los productos). */
export const productSlugs: ProductType[] = [...PRODUCT_SLUGS]

export const getProductById = (id: ProductType): ProductProps => PRODUCTS[id]
export const getPriceByProductId = (id: ProductType): number => PRODUCTS[id].price
export const isBaseProduct = (id: string): id is ProductType => id in PRODUCTS

export default PRODUCTS
